import { useState, useEffect,useRef } from "react";
import ReactDatetime from "react-datetime";
import React from 'react';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
  Col,
  FormGroup,
  InputGroup ,
  InputGroupAddon,
  InputGroupText ,
  
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import 'assets/css/themecustom-style.css';
import { useHistory,useParams,useLocation } from "react-router-dom";
const axios = require("axios");
import {usermanageService} from '../../services/usermanageService';
import {taskmanageService} from '../../services/taskmanageService';
import { ToastContainer, toast } from 'react-toastify';
import { clientmanageService } from "../../services/clientmanageService.js";

import {apiUrl} from '../../constant';
import {authtoken} from '../../global.js';

const SMEClients = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const success = queryParams.get('success');
  
  const user_info = JSON.parse(localStorage.getItem("user-info"));
  const history = useHistory();
  const healthcheckup = (clientId) =>{
    history.push({
      pathname: `healthcheckup/${clientId}`,
    });
  }
  
  const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);
  const [data, setdata] = useState([]);
  const [filterFields,setfilterFields] = useState([]);
  const [filtertype,setfiltertype] = useState('open');
  const [state, setState] = useState({startDate:'',endDate:''});
  const [statesend, setStatesend] = useState({startDate:'',endDate:''});
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total_page,setTotalData] = useState(0);
  const handlePageClick = (e, index) => {
    e.preventDefault();
    get_list(index);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    get_list(prev);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    get_list(next);
  };

  const get_list = async (pageNumber = 1,rowsPerPage='') => {
   
    clientmanageService.getSMEClients(pageNumber,rowsPerPage).then((response) => {
      console.log(response.data)
        setdata(response.data.data.data);
        setCurrentPage(response.data.data.current_page);
        setLastPageData(response.data.data.last_page);
    });
  };
  const [category,setCategory] = useState('hygiene');
  const getData = (title) =>{
    setCategory(title)
  
  }
  const downloadfile = (path, name, extension) => {
    taskmanageService
      .download_file(path, name, extension)
      .then((response) => {});
  };
  useEffect(() => {
    get_list();
  }, []);

  useEffect(() => {
    if (success == 1) {
       toast.success('Xero Organization is connected successfully.');
    }
 }, [success]);
  const [xeroconnect, setxeroconnect] = useState(false);
  function xeroConnect(clientId) {
    if (confirm("Do you want to connect to Xero account?")) {
      window.location.href = `${apiUrl}/xeroConnect?client_id=${clientId}`;
    }
  }
  

  const [xeroTenantname, setxeroTenantname] = useState('');
  function xeroconnectstatus(){
    clientmanageService.xeroconnectstatus().then((response)=>{

          if(response){
            setxeroconnect(true)
            setxeroTenantname(response.data.tenant_name)
          }
      });
  }
  function xeroDisconnect(clientId) {
    clientmanageService.xeroDisconnect(clientId).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.success)
        get_list();
      }else{
        toast.success(response.data.error)
      }
    });
  }

  function refreshData(clientId) {
    clientmanageService.refreshData(clientId).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.success)
        get_list();
      }else{
        toast.success(response.data.error)
      }
    });
  }
  
  return (
    <>
    <Header />
    <Container className="mt--7" fluid>
    <Row>
          {/* <div className="col-3">
            {user_info.role_id !=13 && user_info.department =='SME' ? 
             <Button className="col-12 " color="primary" type="button" onClick={adddocu}>
                Add
             </Button>:null}
          </div> */}
          
          
          </Row>
               
          <Row className="mt-2">
          <div className="col" style={{ padding: "0%" }}>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center row">
                <div className="col-xl-3 col-md-2 col-xs-12">
                  <h3 className="mb-0" style={{ fontSize: "20px" }}>
                    Clients
                  </h3>
                  </div>
                  <div className="col-xl-8 col-md-2 col-xs-12">
                 
                  </div>
                </Row>
                <br></br>
                <Row className="align-items-center row">
                <button type="button"  className=" btn btn-secondary text-center" style={{backgroundColor:category=='hygiene' ? '#11cdef' : ''}} onClick={() => getData('hygiene')}>
           Hygiene
        </button>
       
        <button type="button"  className=" btn btn-secondary text-center" style={{backgroundColor:category=='financial' ? '#11cdef' : ''}} onClick={() => getData('financial')}>
          Financial
        </button> 
       
           
  
  
          </Row>
          <br></br>
              </CardHeader>
              {category=='hygiene' ?
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <th scope="col">XERO Status</th>
                  <th scope="col">Client Name</th>
                  <th scope="col">Health checkup</th>
                  <th scope="col">Type</th>
                  <th scope="col">Date</th>
                  
                  
                </thead>
                <tbody>
                  {data && data.length && data != null ? (
                    data.map((item, i) =>
                      item != undefined ? (
                        <>
                          <tr
                            className={
                              i % 2 == 0
                                ? "blue-row"
                                : i % 3 == 0
                                ? "purple-row"
                                : "orange-row"
                            }
                          >
                            <td style={{width:"10%"}}>
                              {(item.connected == true) ? 
                                <> 
                                <span> Connected </span>
                                <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => refreshData(item.id)}><i className="fas fa-refresh"> </i>  </a><br></br>
                                <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => xeroDisconnect(item.id)}><i className="fas fa-close"> </i> Disconnect </a>
                                </>
                                : 
                              <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => xeroConnect(item.id)}><i className="fas fa-user"> </i> Connect </a>
                              }
                              
                            </td>
                            <td>{item.name}</td>
                            <td style={{width:"10%"}}>
                          
                              <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => healthcheckup(item.id)}><i className="fas fa-eye"> </i>  </a>
                              
                              
                            </td>
                            
                          </tr>
                        </>
                      ) : (
                        <></>
                      )
                    )
                  ) : (
                    <tr>
                      <td colSpan={3}>No Data Found!</td>
                    </tr>
                  )}
                </tbody>
              </Table>
              : <Table>
 <thead className="thead-light">
                  <th scope="col">XERO Status</th>
                  <th scope="col">Client Name</th>
                  {/* <th scope="col">Health checkup</th> */}
                  <th scope="col">Type</th>
                  <th scope="col">Date</th>
                  
                  
                </thead>
                <tbody>
                  {data && data.length && data != null ? (
                    data.map((item, i) =>
                      item != undefined ? (
                        <>
                          <tr
                            className={
                              i % 2 == 0
                                ? "blue-row"
                                : i % 3 == 0
                                ? "purple-row"
                                : "orange-row"
                            }
                          >
                            <td style={{width:"10%"}}>
                              {(item.connected == true) ? <span> Connected </span>: 
                              <a style={{cursor:"pointer",color:"#5d6cae"}}   onClick={() => xeroConnect(item.id)}><i className="fas fa-user"> </i> Connect </a>
                              }
                              
                            </td>
                            <td>{item.name}</td>
                          <td></td>
                          <td></td>
                          </tr>
                        </>
                      ) : (
                        <></>
                      )
                    )
                  ) : (
                    <tr>
                      <td colSpan={3}>No Data Found!</td>
                    </tr>
                  )}
                </tbody>
              </Table> 
              }
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem disabled={currentPage <= 1}>
                      <PaginationLink onClick={handlePreviousClick} previous />
                    </PaginationItem>
                    {[...Array(last_page)].map((page, i) => (
                      <PaginationItem
                        active={i + 1 === currentPage}
                        key={i + 1}
                      >
                        <PaginationLink
                          onClick={(e) => handlePageClick(e, i + 1)}
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={currentPage >= last_page}>
                      <PaginationLink onClick={handleNextClick} next />
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
     </Container>
    </>
  );
};


export default SMEClients;
